"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskTypeMenuButton = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const useDeleteTaskType_1 = require("../hooks/useDeleteTaskType");
const TaskTypeMenuButton = props => {
    const { taskType, onChange, onClickUpdate } = props;
    const onChangeRef = (0, react_1.useRef)(onChange);
    const [openDeleteDialog, setOpenDeleteDialog] = (0, react_1.useState)(false);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const { data: deletedTaskType, error, deleteTaskType } = (0, useDeleteTaskType_1.useDeleteTaskType)(taskType.id);
    (0, react_1.useEffect)(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (deletedTaskType) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, deletedTaskType);
        }
    }, [deletedTaskType]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: event => {
                event.preventDefault();
                setAnchorEl(event.currentTarget);
            } },
            react_1.default.createElement(core_1.Icon, { className: 'more-icon' }, "more_vert")),
        react_1.default.createElement(core_1.Menu, { id: 'workflow-more-menu', open: !!anchorEl, anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => setAnchorEl(null) },
            react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                    setAnchorEl(null);
                    onClickUpdate === null || onClickUpdate === void 0 ? void 0 : onClickUpdate();
                } }, "Update Task Type"),
            react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                    setAnchorEl(null);
                    setOpenDeleteDialog(true);
                } }, "Delete Task Type")),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: openDeleteDialog, title: 'Delete Task Type', message: `Are you sure you want to delete "${taskType.label} (${taskType.prefix})"? `, confirmLabel: 'Delete', onCancel: () => setOpenDeleteDialog(false), onConfirm: () => {
                setOpenDeleteDialog(false);
                deleteTaskType();
            } }),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!error }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')));
};
exports.TaskTypeMenuButton = TaskTypeMenuButton;
exports.default = exports.TaskTypeMenuButton;
//# sourceMappingURL=TaskTypeMenuButton.js.map